import { Box, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';

interface CP67BoxDoorProps {
    top: number;
    left: number;
    height: number;
    doorNumber: number;
    active: boolean;
    isCU?: boolean;
}

const Square = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'left' && prop !== 'top' && prop !== 'height' && prop !== 'isCU',
})<{ left: number; top: number; height: number; active: boolean; isCU?: boolean }>(({ theme, left, top, height, active, isCU }) => ({
    position: 'absolute',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    paddingRight: '8px',
    paddingBottom: '2px',
    border: '1px solid black',
    width: '60px',
    top: `${top}px`,
    left: `${left}px`,
    height: `${height}px`,
    backgroundColor: isCU ? '#E0E0E0' : (active ? theme.palette.primary.light : theme.palette.primary.dark),
}));

const NumberText = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'active',
})<{ active: boolean }>(({ active }) => ({
    color: active ? 'white' : 'black',
    fontWeight: 'normal',
    fontSize: '11px',
}));

const CP67BoxDoor = (props: CP67BoxDoorProps) => {
    const theme = useTheme();

    return (
        <Square
            left={props.left}
            top={props.top}
            height={props.height}
            active={props.active}
            isCU={props.isCU}
        >
            {!props.isCU && <NumberText active={props.active}>{props.doorNumber}</NumberText>}
        </Square>
    );
};

export default CP67BoxDoor;
